import {MQTT_INITIALIZE, MQTT_SUBCRIBE_TOPIC, MQTT_UNSUBCRIBE_TOPIC} from './constants'

export function initializeMqtt() {
  return {type: MQTT_INITIALIZE}
}

export function subcribeTopic(newTopicState) {
  return {type: MQTT_SUBCRIBE_TOPIC, newTopicState}
}

export function unsubcribeTopic(newTopicState) {
  return {type: MQTT_UNSUBCRIBE_TOPIC, newTopicState}
}



// WEBPACK FOOTER //
// ./src/actions/mqtt.js